import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {retriveToken} from "../../services/AuthServices";
import ForgotPassword from "./ForgotPassword";
import "../../components/basic/homepage/homepage.css";
import "../../components/basic/homepage/homepage.jpg";

const Forgot = () => {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  if (retriveToken() && retriveToken() !== "undefined") {
    // If already logged in, redirect to the user homepage
    navigate("/user/home", { replace: true });
    return null;
  } else {
    return (
      <div className="home-page-container">
        <div className="parallax">
          {/* <HomepageHeader /> */}
          <ForgotPassword />
        </div>
      </div>
    );
  }
};

export default Forgot;
